import React, {lazy, Suspense} from "react";
import {Routes, Route, } from "react-router-dom";
import comm_key_def from "../comm/comm_key_def";

const Home = lazy(() => import("../pages/home/home"));
const Order = lazy(() => import("../pages/order/order"));
const Mine = lazy(() => import("../pages/mine/mine_index"));
const IdCardType = lazy(() => import("../pages/auth/IdCardType"));
const Login = lazy(() => import("../pages/login/login"));
const ProductDetail = lazy(() => import("../pages/product_detail/product_detail"));
const PrivacyAgreement = lazy(() => import("../pages/other/privacyAgreement"));
const IFrame = lazy(() => import("../pages/other/IFrame"));
const AboutUs = lazy(() => import("../pages/other/AboutUs"));
const CustomerService = lazy(() => import("../pages/other/customerService"));
const ComplainPage = lazy(() => import("../pages/other/complaintModule/complainPage"));
const ComplainDetails = lazy(() => import("../pages/other/complaintModule/complainDetails"));
const ComplainPageNext = lazy(() => import("../pages/other/complaintModule/complainPageNext"));
const ComplaintList = lazy(() => import("../pages/other/complaintModule/complaintList"));
const Auth = lazy(() => import("../pages/auth/auth"));
const ConfirmLoan = lazy(() => import("../pages/confirmLoan/confirm_loan"));
const OrderDetail = lazy(() => import("../pages/orderDetail/order_detail"));
const RepaymentOfPeriod = lazy(() => import("../pages/repay/repaymentOfPeriod/repaymentOfPeriod"));
const RepaymentOfDelay = lazy(() => import("../pages/repay/repaymentOfPeriod/repaymentOfDelay"));
const YnRepay = lazy(() => import("../pages/repay/ynRepay/ynRepay"));
const YnRepayChoose = lazy(() => import("../pages/repay/ynRepay/ynRepayChoose"));
const Setting = lazy(() => import("../pages/mine/setting/setting"));
const Logout = lazy(() => import("../pages/mine/setting/logout"));
// const FaceDetection = lazy(() => import("../components/FaceDetection/index"));
// const LandingPage = lazy(() => import("../pages/other/landing_page"));
// const LandingPage2 = lazy(() => import("../pages/other/landing_page2"));
// const Official = lazy(() => import("../pages/official/official"));


export default function RoutesConfig() {
    return (
        <Suspense fallback={null}>
            <Routes>
                {/*<Route path="/" element={<Official/>}></Route>*/}
                <Route path={comm_key_def.main} element={<Home/>}></Route>
                <Route path={comm_key_def.order} element={<Order/>}></Route>
                <Route path={comm_key_def.mine} element={<Mine/>}></Route>
                <Route path={comm_key_def.login} element={<Login/>}></Route>
                <Route path={comm_key_def.productDetail} element={<ProductDetail/>}></Route>
                <Route path={comm_key_def.auth} element={<Auth/>}></Route>
                <Route path={comm_key_def.confirmUrl} element={<ConfirmLoan/>}></Route>
                {/*<Route path={comm_key_def.orderUrl} element={<OrderDetail/>}></Route>*/}
                <Route path={comm_key_def.loanDetailUrl} element={<OrderDetail/>}></Route>
                <Route path={comm_key_def.repayUrl} element={<RepaymentOfPeriod/>}></Route>
                <Route path={comm_key_def.repayDelayUrl} element={<RepaymentOfDelay/>}></Route>
                {/*<Route path={comm_key_def.ynRepay} element={<YnRepay/>}></Route>*/}
                {/*<Route path={comm_key_def.ynRepayChoose} element={<YnRepayChoose/>}></Route>*/}
                <Route path={comm_key_def.setting} element={<Setting/>}></Route>
                <Route path={comm_key_def.logout} element={<Logout/>}></Route>
                {/*<Route path={comm_key_def.faceDetection} element={<FaceDetection/>}></Route>*/}
                <Route path={comm_key_def.privacyPolicy} element={<PrivacyAgreement/>}></Route>
                <Route path={comm_key_def.aboutUs} element={<AboutUs/>}></Route>
                <Route path={comm_key_def.customerService} element={<CustomerService/>}></Route>
                <Route path={comm_key_def.complaint} element={<ComplainPage/>}></Route>
                <Route path="complainDetails" element={<ComplainDetails/>}></Route>
                <Route path="iframe" element={<IFrame/>}></Route>
                <Route path="complainPageNext" element={<ComplainPageNext/>}></Route>
                <Route path="complaintList" element={<ComplaintList/>}></Route>
                <Route path="/IdCardType" element={<IdCardType/>}></Route>
                {/*<Route path="landing" element={<LandingPage/>}></Route>*/}
                {/*<Route path="landing2" element={<LandingPage2/>}></Route>*/}

            </Routes>
        </Suspense>
    )
}
